import {
  DataPersonEntityRaw,
  dataPersonEntityRaw,
} from '@edgvr-front/data/domain';
import { Validate } from '@edgvr-front/util/validate';

export class DataPersonGetResponseDTO {
  private static validation = Validate.compile(
    DataPersonGetResponseDTO.validationSchema()
  );

  constructor(readonly data: DataPersonGetResponseDTORaw) {
    Validate.assert(DataPersonGetResponseDTO.validation, data);
  }

  private static validationSchema() {
    return {
      type: 'object',
      required: ['dataPerson'],
      properties: {
        dataPerson: dataPersonEntityRaw,
      },
    };
  }
}

interface DataPersonGetResponseDTORaw {
  dataPerson: DataPersonEntityRaw;
}
